/**
 * Trade Toggle Component
 * 
 * Toggle between Buy and Sell trading modes
 * Sell is only available when user has a position
 */

import React from 'react';
import './TradeToggle.css';

export type TradeMode = 'buy' | 'sell';

interface TradeToggleProps {
  activeMode: TradeMode;
  onToggle: (mode: TradeMode) => void;
  hasPosition?: boolean; // Whether user has an existing position
  disabled?: boolean; // Disable all toggle buttons (e.g., when market ended with no position)
  disableBuy?: boolean; // Disable only the Buy button (e.g., when market ended but user has position to sell)
}

export const TradeToggle: React.FC<TradeToggleProps> = ({
  activeMode,
  onToggle,
  hasPosition = false,
  disabled = false,
  disableBuy = false
}) => {
  return (
    <div className={`trade-toggle-container ${disabled ? 'disabled' : ''}`}>
      <button
        className={`trade-toggle-button ${activeMode === 'buy' ? 'active' : ''}`}
        onClick={() => onToggle('buy')}
        disabled={disabled || disableBuy}
      >
        Buy
      </button>
      <button
        className={`trade-toggle-button ${activeMode === 'sell' ? 'active' : ''}`}
        onClick={() => onToggle('sell')}
        disabled={disabled || !hasPosition}
        title={!hasPosition ? 'You need a position to sell' : ''}
      >
        Sell
      </button>
    </div>
  );
};
